// Libraries
var React = require('react');

// Styles
require('./VideoEmbedStream.scss');

class VideoEmbedStream extends React.Component {

	// Generates unique UID to handle the div where the embedded video will be placed.
	uuidv4 = () => {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			let r = Math.random() * 16 | 0;
			let v = c === 'x' ? r : ((r & 0x3) | 0x8);
			return v.toString(16);
		});
	};

	constructor(props) {
		super(props);

		this.state = {
			targetId: this.uuidv4(),
			tickInterval: null,
			playerElement: null,
			defaultMParticleEventObject: window.defaultMParticleEventObject,
			eventData: null,
			allowVideoEventPush: true,
			lastVideoEventNamePushed: '',
			lastVideoEventActionTypePushed: ''
		};
	}

	componentDidMount() {

		// Makes sure to not load the JS lib again.
		// There could be a case where different playerId variations exists,
		// but internally, Stream does this anyway.
		// A workaround would be to store the specific kWidget object globally and
		// set it to undefined before re-adding the script.

		if (typeof window['kWidget'] === 'undefined') {
			let kalturaUrl = window.location.protocol + "//open.http.mp.streamamg.com/p/" + this.props.partnerId + "/sp/" + this.props.partnerId + "00/embedIframeJs/uiconf_id/" + this.props.playerId + "/partner_id/" + this.props.partnerId;
			let scriptTag = document.createElement('script');

			scriptTag.src = kalturaUrl;
			document.getElementsByTagName('body')[0].appendChild(scriptTag);

			let poll = 0;
			let timer = setInterval(() => {
				if (typeof window['kWidget'] !== 'undefined') {
					clearInterval(timer);
					this.createPlayer();
				} else if (poll > 1000) {
					clearInterval(timer);
					console.warn('Timed out waiting for kWidget.');
				} else {
					poll += 1;
				}
			}, 50);
		} else {
			this.createPlayer();
		}
	}

	componentWillUnmount() {

		clearInterval(this.state.tickInterval);

		this.setState({ tickInterval: null });
		
		if (this.state.playerElement) {
			
			window.kWidget.destroy(this.state.targetId);

			this.setState({ playerElement: null });

			const eventData = this.state.eventData;
			this.pushToDataLayer(eventData, 'video_ended', 'manual');

			this.setState({ eventData: null });

		}

	}

	padDate(date, min) {

		return date.toString().padStart(min, '0');

	}

	parseUnixTimestamp(timestamp) {

		if (!timestamp) return null;

		const convertedTimestamp = timestamp * 1000;

		const date = new Date(convertedTimestamp);
		let year = date.getFullYear();
		let month = date.getMonth() + 1; // (note zero index: Jan = 0, Dec = 11)
		let day = date.getDate();

		month = this.padDate(month, 2);
		day = this.padDate(day, 2);

		return `${year}-${month}-${day}`;

	}

	parseTags(tags) {

		if (!tags) return null;

		const find = ', ';
		const replace = '|';

		return tags.replace(new RegExp(find, 'g'), replace);

	}

	parseType(type) {

		if (!type) return null;

		return (type === 7 || type === 8) ? 'streaming' : 'on_demand';

	}

	determineIfDuplicateEvent(eventName, actionType) {

		if (eventName === 'video_play_ticked') {

			return false;

		}

		return (this.state.lastVideoEventNamePushed === eventName) && (this.state.lastVideoEventActionTypePushed === actionType);

	}

	pushToDataLayer(defaultData, eventName, actionType) {

		// Catch dupe 'video_play_ticked' events using timeout and bin them off
		// They are able to fire in succession so can't be caught by the function 'determineIfDuplicateEvent'

		if (eventName === 'video_play_ticked' && !this.state.allowVideoEventPush) { 

			return false;

		}

		// Catch other dupe events using function 'determineIfDuplicateEvent' and bin them off

		const isDupe = this.determineIfDuplicateEvent(eventName, actionType);

		if (isDupe) {

			return false;

		}

		if (!defaultData || !eventName || !actionType) {

			return false;

		}

		this.setState({
			allowVideoEventPush: false,
			lastVideoEventNamePushed: eventName,
			lastVideoEventActionTypePushed: actionType
		});

		let eventData = defaultData;

		eventData.event = eventName;
		eventData.action_type = actionType;

		const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(eventDataMerged);

		setTimeout(() => {

			this.setState({allowVideoEventPush: true});

		}, 500);

	}

	pushToDataLayerContentSelect(eventData) {

		let placementName = 'other';

		if (this.state.playerElement) {

			const placementNameTarget = this.state.playerElement.closest('[data-placement-name]');
			placementName = placementNameTarget ? placementNameTarget.getAttribute('data-placement-name') : placementName;

		}

		eventData.event = 'content_selected';
		eventData.placement_type = 'list';
		eventData.placement_name = placementName;

		const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
		window.dataLayer.push(eventDataMerged);

	}

	createPlayer() {

		window.kWidget.embed({
			"targetId": this.state.targetId,
			"wid": "_" + this.props.partnerId,
			"uiconf_id": this.props.playerId,
			"flashvars": {
				//"hlsjs.plugin": true,
				"EmbedPlayer.EnableIpadHTMLControls": false,
				"streamerType": "auto",
				"autoPlay": true,
				"autoPMute": true
				//"audioSelector.defaultLanguage": "en",
				//"localizationCode": "en",
			},
			//"cache_st": Math.floor(new Date().getTime() / 3600000),
			"entry_id": this.props.entryId
		});

		// https://developer.kaltura.com/api-docs/Enrich-and-Organize-Metadata/how-retrieve-metadata-media-entry-using-api.html
		// https://www.kaltura.com/api_v3/testmeDoc/objects/KalturaMediaEntry.html - DESCRIBES object videoInfo

		window.kWidget.addReadyCallback((playerId) => {

			let playerElement = document.getElementById(playerId);

			let seekedCount = 0;

			this.setState({playerElement: playerElement}, () => {

				let eventData;

				this.state.playerElement.kBind('metadataReceived', () => {

					var videoInfo = this.state.playerElement.evaluate('{mediaProxy.entry}');

					eventData = {
						content_access_type: 'free',
						content_id: videoInfo.id,
						content_type: 'video',
						content_tags: this.parseTags(videoInfo.tags),
						content_title: videoInfo.name,
						content_publication_date: this.parseUnixTimestamp(videoInfo.createdAt),
						content_duration: videoInfo.duration,
						video_stream_type: this.parseType(videoInfo.type),
						interval_sec: 10
					};

					this.setState({eventData: eventData});

					this.pushToDataLayerContentSelect(eventData);

				});

				this.state.playerElement.kBind('play', () => {

					this.pushToDataLayer(eventData, 'video_played', 'manual');

					clearInterval(this.state.tickInterval);

					let intervalId = setInterval(() => {

						if (this.state.playerElement) {
						
							this.pushToDataLayer(eventData, 'video_play_ticked', 'auto');
						
						}
	
					}, 10000);
					
					this.setState({tickInterval: intervalId});
	
				});
	
				this.state.playerElement.kBind('pause', () => {
					
					this.pushToDataLayer(eventData, 'video_paused', 'manual');

					clearInterval(this.state.tickInterval);
	
				});
	
				this.state.playerElement.kBind('ended', () => {
					
					this.pushToDataLayer(eventData, 'video_ended', 'auto');

					clearInterval(this.state.tickInterval);
	
				});

				this.state.playerElement.kBind('playerSeekEnd', () => {
					
					if (seekedCount > 0) { clearInterval(this.state.tickInterval); }
					seekedCount++;

				});

			});

		});
		
	};

	render() {

		return (
			<div className="VideoEmbedStream">
				<div id={this.state.targetId}/>
			</div>
		)
	}
}

module.exports = VideoEmbedStream;



// WEBPACK FOOTER //
// ./src/components/Video/VideoEmbedStream.js